// extracted by mini-css-extract-plugin
export default {"rangeBox":"oF3F33PVoScuCy37wFjW","slider":"lrmPJaZp1KWPEjY3nxsc"};